import { render, staticRenderFns } from "./CandidateEmailVerification.vue?vue&type=template&id=6c69549a"
import script from "./CandidateEmailVerification.vue?vue&type=script&lang=js"
export * from "./CandidateEmailVerification.vue?vue&type=script&lang=js"
import style0 from "./CandidateEmailVerification.vue?vue&type=style&index=0&id=6c69549a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports